import { render, staticRenderFns } from "./arrearsSet.vue?vue&type=template&id=2bc4d9e4&scoped=true&"
import script from "./arrearsSet.vue?vue&type=script&lang=js&"
export * from "./arrearsSet.vue?vue&type=script&lang=js&"
import style0 from "./arrearsSet.vue?vue&type=style&index=0&id=2bc4d9e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4d9e4",
  null
  
)

export default component.exports